import React from 'react';

export const facebookIcon = () => {
  return (
    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M25.7778 -0.000244141H3.22222C1.45 -0.000244141 0 1.44976 0 3.22198V25.7775C0 27.5514 1.45 28.9998 3.22222 28.9998H14.5V17.722H11.2778V13.7345H14.5V10.4317C14.5 6.94526 16.4527 4.49637 20.5674 4.49637L23.4723 4.49959V8.69653H21.5438C19.9423 8.69653 19.3333 9.89842 19.3333 11.0133V13.7361H23.4707L22.5556 17.722H19.3333V28.9998H25.7778C27.55 28.9998 29 27.5514 29 25.7775V3.22198C29 1.44976 27.55 -0.000244141 25.7778 -0.000244141Z" fill="white" />
    </svg>
  );
};
